import { CheckBox, DisabledByDefault, QuestionMark, WatchLater } from "@mui/icons-material"
import { Tooltip } from "@mui/material"
import { format } from 'date-fns'
const ParentalConsentCell = ({ parentalConsentStatus, lastSent }: { parentalConsentStatus: string, lastSent?: string }) => {
    switch (parentalConsentStatus) {
        case "Given":
            return (
                <Tooltip title="Consent Given">
                    <div style={{ padding: "8px" }}>
                        <CheckBox color="primary" />
                    </div>
                </Tooltip >
            )
        case "Pending":
            const message = lastSent ? <>Response Pending <br /> Last sent on {format(new Date(lastSent), "MM/dd/yyyy")}</> : "Response Pending"
            return (<Tooltip title={message}>
                <div style={{ padding: "8px" }}>
                    <WatchLater sx={{ color: "gray" }} />
                </div>
            </Tooltip>)
        case "Rejected":
            return (<Tooltip title="Consent Not Given">
                <div style={{ padding: "8px" }}>
                    <DisabledByDefault sx={{ color: "red" }} />
                </div>
            </Tooltip>)
        case "Timelapsed":
            return (
                <Tooltip title="Consent given via time lapse">
                    <div style={{ padding: "8px" }}>
                        <CheckBox sx={{ color: "primary.light" }} />
                    </div>
                </Tooltip>
            )
        default:
            return (
                <Tooltip title="Not Requested">
                    <div style={{ padding: "8px" }}>
                        <QuestionMark sx={{ color: "gray" }} />
                    </div>
                </Tooltip >)
    }

}

export default ParentalConsentCell